<template>
  <div>
    <PriorityAdd />
  </div>
</template>

<script>
import PriorityAdd from "./PriorityAdd.vue";

export default {
  components: {
    PriorityAdd,
  },

  data() {
    return {};
  },
};
</script>
